module.exports = __webpack_public_path__ + "static/1_1_defineai_DE-c065b2bcf0b4cc0b33f5d5fb5b4ce82d.svg";